import { Money } from '@/models/money';
import { SubCategory } from '@/models/product';

/**
 * Whether or not the provided object has an array of children
 */
export const isParent = ({ children }: { children?: Array<unknown> | null }) => !!children?.length;

/**
 * Whether or not the product or its children have base unit pricing and
 * a base unit of measure
 */
export const hasBaseUnitPricing = (product: {
  baseUnitPrice?: Money | null;
  children?: Array<{
    baseUnitPrice?: Money | null;
    subCategory: SubCategory;
  }> | null;
  subCategory: SubCategory;
}): boolean => {
  const { baseUnitPrice, children, subCategory } = product;

  return (
    !!(!isParent(product) && !!baseUnitPrice && subCategory.baseUnitOfMeasureShortName) ||
    !!(isParent(product) && children?.every((i) => !!i.baseUnitPrice && i.subCategory.baseUnitOfMeasureShortName))
  );
};

/**
 * Whether or not the product or its children have a sale price
 */
export const hasSalePrice = (product: {
  children?: Array<{ salePrice?: Money | null }> | null;
  salePrice?: Money | null;
}): boolean => {
  return isParent(product) ? !!product.children?.some((p) => p?.salePrice) : !!product.salePrice;
};

/**
 * Whether or not the product or its children have a volume discount
 */
export const hasVolumeDiscount = (product: {
  children?: Array<{ hasVolumeDiscount?: boolean | null }> | null;
  hasVolumeDiscount?: boolean | null;
}): boolean => {
  return isParent(product) ? !!product.children?.some((p) => p.hasVolumeDiscount) : !!product.hasVolumeDiscount;
};
